import {createTheme, MantineColorsTuple} from '@mantine/core';

// Primary: #e9613d — 10 shades from light to dark
const forgePrimary: MantineColorsTuple = [
    '#fff1ec',  // 0 - lightest
    '#ffe0d5',  // 1
    '#fbbfaa',  // 2
    '#f59c7b',  // 3
    '#f07e55',  // 4
    '#e9613d',  // 5 - base (your primary)
    '#d44e2d',  // 6
    '#b53d21',  // 7
    '#932f18',  // 8
    '#722310',  // 9 - darkest
];

// Accent/secondary: #e5a51c — 10 shades from light to dark
const forgeGold: MantineColorsTuple = [
    '#fff8e1',  // 0 - lightest
    '#ffecb3',  // 1
    '#ffe082',  // 2
    '#ffd34f',  // 3
    '#f5c528',  // 4
    '#e5a51c',  // 5 - base (your accent)
    '#c98d14',  // 6
    '#a8720d',  // 7
    '#875a08',  // 8
    '#664404',  // 9 - darkest
];

export const forgeTheme = createTheme({
    primaryColor: 'forge',
    colors: {
        forge: forgePrimary,
        gold: forgeGold,
    },

    fontFamily: 'Roboto, sans-serif',

    defaultRadius: 'sm',

    components: {
        Button: {
            defaultProps: {
                variant: 'filled',
            },
        },
        Paper: {
            defaultProps: {
                shadow: 'xs',
                p: 'md',
                withBorder: true,
            },
        },
        ActionIcon: {
            defaultProps: {
                radius: 'xl',
            },
        },
    },
});
